/* カートを「商品だけの形」に戻す（2026-10-29 藤田さん：入力のあとでも数量を変えたり、商品をやめたりできるように）
   お届け先・お届け日の入力画面（/cart?view=multi）で「お支払いへ進む」を押すと、カートを次の形に組み替えている：
     ・お届け先ごとの行（_お届け先ID）、1個ずつ分けた行（_個目）
     ・送料の行（ms-ship-ambient／ms-ship-frozen）、メッセージカードの行（ksv-message-card）
   お支払い画面から戻ってきたとき、この形のままだと数量を変えられない・カードの枚数が残るので、
   入力画面以外のページを開いたら、同じ商品をまとめた元の形に戻す。
   ・入力したお届け先・熨斗・カード・割り振りは、このタブの控え（sessionStorage）に残っているので、入力画面で元に戻る
   ・入力画面（/cart?view=multi）とお支払い画面では何もしない（入力画面は自分で読み直す） */
(function () {
  try {
    var p = location.pathname, q = location.search || '';
    if (/\/checkouts?\b/.test(p) || /\/thank_you/.test(p)) return;
    if (/\/cart\/?$/.test(p) && /[?&]view=multi\b/.test(q)) return;
    if (window.__ksvTidy) return; window.__ksvTidy = true;
  } catch (e) { return; }

  var SHIP = ['ms-ship-ambient', 'ms-ship-frozen'], CARD = 'ksv-message-card';
  /* 入力画面が足したメッセージカードの行（「添える商品」かお届け先の番号が付いている）。商品ページから入れたカードは残す */
  function genCard(i) { var p = i.properties || {}; return i.handle === CARD && !!(p['添える商品'] || p['_お届け先ID']); }
  function isFee(i) { return SHIP.indexOf(i.handle) >= 0 || genCard(i); }
  /* 入力画面が入れる項目（ksv-order.js の MSK・NOSHI_KEYS と同じ）。まとめるときは外す */
  var GEN = ['お届け先', '熨斗', 'メッセージカード', 'お届け希望日', 'お届け日・熨斗', '_お届け希望日', '_熨斗', '_掛け方', '_メッセージカード',
    '_お届け先ID', '_お届け先住所', '_お届け先電話', '添える商品', '_個目', '表書き', '名入れ', '掛け方', '_熨斗元', '_熨斗表示', '表書き・お名前'];
  /* これがあれば「組み替えたあとの形」 */
  /* 「掛け方」は入力画面だけが入れる（商品ページ・今の本番のカートは入れない）。今の本番の形のカート（熨斗・表書き・お名前）はそのまま */
  var MARK = ['_お届け先ID', '_個目', 'お届け日・熨斗', '_お届け希望日', 'お届け希望日', '掛け方', '_掛け方'];

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function hasKey(o, keys) { o = o || {}; for (var i = 0; i < keys.length; i++) if (o[keys[i]] != null && o[keys[i]] !== '') return true; return false; }

  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
    var items = c.items || [];
    if (!items.length) return;
    var gen = items.some(function (i) { return isFee(i) || hasKey(i.properties, MARK); });
    if (!gen) return;

    /* 同じ商品・同じ入力内容（名入れなど、入力画面が入れたもの以外）をまとめる */
    var map = {}, lines = [];
    items.forEach(function (i) {
      if (isFee(i)) return;
      var pr = i.properties || {}, base = {}, sig = {};
      Object.keys(pr).forEach(function (k) {
        if (GEN.indexOf(k) >= 0 || pr[k] === '' || pr[k] == null) return;
        base[k] = pr[k];
        if (k.charAt(0) !== '_') sig[k] = pr[k];
      });
      var key = i.variant_id + '|' + JSON.stringify(Object.keys(sig).sort().map(function (k) { return [k, sig[k]]; }));
      if (map[key]) { map[key].quantity += i.quantity; return; }
      map[key] = { id: i.variant_id, quantity: i.quantity, properties: base };
      lines.push(map[key]);
    });

    /* 表示：カートを整えている間だけ */
    var ov = document.createElement('div');
    ov.setAttribute('role', 'status');
    ov.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.85);font-size:14px;color:#3A4040;letter-spacing:.04em';
    ov.textContent = 'カートの内容を整えています…';
    var show = function () { if (document.body) document.body.appendChild(ov); };
    if (document.body) show(); else document.addEventListener('DOMContentLoaded', show);

    var up = {}; items.forEach(function (i) { up[i.key] = 0; });
    post('/cart/update.js', { updates: up })
      .then(function () { return lines.length ? post('/cart/add.js', { items: lines.slice().reverse() }) : null; })
      /* 「複数のお届け先」だけ外す（カートのページがお届け先ごとの一覧の表示になるため）。お届け先の控え（_ms_recipients など）は残す */
      .then(function () { return post('/cart/update.js', { attributes: { '複数のお届け先': '' } }); })
      .then(function () { location.reload(); })
      .catch(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); });
  }).catch(function () {});
})();
